import React, { useEffect, useState } from 'react';
import { FaTimes } from 'react-icons/fa';
import { ReactComponent as ImageAddIcon } from '../assets/svg/ImageAddIcon.svg';
import { uploadFile } from '../server/server';
import { checkAllowedExtensions } from '../utils/util';

function ImageComponent({
	image,
	setImage,
	imageId,
	setImageId,
	errorCheck,
	elementId = 'photo_upload_modal',
}: {
	image: string | undefined;
	setImage: any;
	imageId: string;
	setImageId: any;
	errorCheck?: any;
	elementId?: string;
}) {
	const [selectedFile, setSelectedFile] = useState();

	useEffect(() => {
		if (!selectedFile) {
			setImage(undefined);
			console.log('undefined img');
			return;
		}
		console.log('set img');
		const objectUrl = URL.createObjectURL(selectedFile);
		setImage(objectUrl);
		// return () => {
		// 	console.log("remove img trigerovan u create conteern modelu");
		// 	URL.revokeObjectURL(objectUrl);
		// };
	}, [selectedFile]);

	const press_upload = () => {
		document.getElementById(elementId)?.click();
	};

	const closeImage = () => {
		setImage(undefined);
		setImageId('');
		setSelectedFile(undefined);
	};

	const onImageChange = async (e: any) => {
		console.log(image);
		if (!e.target.files || e.target.files.length === 0) {
			setSelectedFile(undefined);
			return;
		}
		let file = e.target.files[0];
		if (file.size > 15728640) {
			alert('File is too big!');
			setSelectedFile(undefined);
			return;
		}
		if (!checkAllowedExtensions(file.name)) {
			alert('Type of file is not allowed!');
			return;
		}
		const resp = await uploadFile({ file: file });
		if (resp.status == 201) {
			const uploadedImage = resp.data;
			setImageId(uploadedImage.id);
		} else {
			return;
		}
		console.log('Selected file : ', file);
		setSelectedFile(file);
	};
	const resetInputValue = (e: any) => {
		e.target.value = null;
	};
	return (
		<div className='flex flex-col justify-center items-center '>
			{!image && (
				<div className='flex flex-col items-center justify-center bg-greyBackground rounded-xl py-8 w-[334px]'>
					<ImageAddIcon style={{ width: 42, height: 42, color: '#8484b1' }} />
					<p className='text-mudPurple text-[16px] leading-5 font-semibold text-center w-[160px]'>The maximum image size for download is 1400px x 1400px</p>
					<button
						className='text-primaryViolet rounded-full bg-lightBG py-1 text-[16px] leading-5 font-semibold px-5 mt-3'
						onClick={(e) => {
							e.preventDefault();
							press_upload();
						}}
					>
						Add Photo
					</button>
				</div>
			)}
			{image && (
				<div className='flex relative max-h-[244px] flex-col items-center justify-center bg-greyBackground rounded-xl pt-12 pb-4 w-[334px]'>
					<div onClick={() => closeImage()} className='bg-white opacity-40 p-2 rounded-full cursor-pointer border border-greyLight absolute top-[8px] right-[8px] hover:border-greyMedium'>
						<FaTimes style={{ width: 20, height: 20, stroke: 'white', display: 'block' }} />
					</div>

					<img style={{ objectFit: 'contain', width: '100%', minHeight: 170 }} src={image} alt='' />
				</div>
			)}
			<input title='Add Video/Photo' style={{ display: 'none' }} accept='video/*, image/*' type='file' id='photo_upload_modal' onChange={onImageChange} onClick={resetInputValue} />
			<p className='text-redError font-medium text-[14px] leading-5 h-5 '>{errorCheck && imageId === '' ? '* Image is required' : ''}</p>
		</div>
	);
}

export default ImageComponent;
